import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { TRANSPORT_TYPE } from 'src/app/constants';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { TruckService } from 'src/app/services/truck/truck.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Truck } from 'src/app/models/truck';
import { Events } from '@ionic/angular';

const INPUT_FORMAT = 'DD/MM/YYYY';

@Component({
  selector: 'app-truck-detail',
  templateUrl: './truck-detail.page.html',
  styleUrls: ['./truck-detail.page.scss'],
})
export class TruckDetailPage implements OnInit {

  truck: Truck;

  truckDataForm: FormGroup;
  disabledByDefault: boolean = true;
  transportTypes = Object.keys(TRANSPORT_TYPE).filter(key => key !== TRANSPORT_TYPE.all);
 
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private events: Events,
    private alertService: AlertService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private truckService: TruckService,
  ) { 
    this.truckDataForm = this.formBuilder.group({
      numberPlate: [{ value: '', disabled: this.disabledByDefault }],
      name: ['', [Validators.maxLength(150)]],
      titleHolder: ['', [Validators.required, Validators.maxLength(150)]],
      kilometers: ['', [Validators.maxLength(150)]],
      transportType: [{ value: '', disabled: this.disabledByDefault }],
      expirationTruck: this.formBuilder.group({
        insurance: [{ value: '', disabled: this.disabledByDefault }],
        fee: ['', Validators.required],
        inspection: ['', Validators.required],
      }),
      specifications: ['', Validators.maxLength(320)],
    });

    if (this.router.getCurrentNavigation().extras.state.truck) {
      const temp = this.router.getCurrentNavigation().extras.state.truck;
      this.truck = temp;
    }
  }

  ngOnInit() {
    this.fillFormFields();
  }

  fillFormFields() {
    if (this.truck) {
      this.truckDataForm.patchValue({
        ...this.truck,
    });
    
    const { expiry } = this.truck.external; 
    this.truckDataForm.patchValue({ expirationTruck : { insurance: expiry ? moment(expiry).format(INPUT_FORMAT) : expiry } });

    const { fee, inspection } = this.truck.expiration;
    this.truckDataForm.patchValue({ expirationTruck : { fee: fee ? moment(fee).format(INPUT_FORMAT) : fee } });
    this.truckDataForm.patchValue({ expirationTruck : { inspection: inspection ? moment(inspection).format(INPUT_FORMAT) : inspection } });
    }
  }
  
  selectedFeeExpirationDate(date: moment.Moment) {
    this.truckDataForm.get('expirationTruck').get('fee').setValue(date.format(INPUT_FORMAT));
  }

  selectedInspectionExpirationDate(date: moment.Moment) {
    this.truckDataForm.get('expirationTruck').get('inspection').setValue(date.format(INPUT_FORMAT));
  }

  async confirmTruckData() {
    await this.alertService.confirm({
      messageKey: 'VEHICLE_UPDATE_DATA',
      okHandler: async () => await this.updateTruckData() 
    });
  }

  async updateTruckData() {
    try {
      await this.spinnerService.show();

      const token = await this.authService.getToken();

      const raw = this.truckDataForm.getRawValue();

      const callbackObj = this.truck;

      callbackObj.name = raw.name;
      callbackObj.titleHolder = raw.titleHolder;
      callbackObj.kilometers = raw.kilometers;
      let feeExpDate = raw.expirationTruck.fee;
      let inspecExpDate = raw.expirationTruck.inspection;
      callbackObj.expiration.fee = feeExpDate ? moment(feeExpDate, INPUT_FORMAT).toDate() : null;
      callbackObj.expiration.inspection = inspecExpDate ? moment(inspecExpDate, INPUT_FORMAT).toDate() : null;
      callbackObj.specifications = raw.specifications;

      await this.truckService.updateTruckData(token, callbackObj.id, callbackObj);

      await this.alertService.toastSuccess();
      await this.spinnerService.dismiss();

      this.events.publish('callback-truck');

      this.router.navigate(['/profile'], { replaceUrl: true });
    } catch (err) {
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

  async confirmTruckDeletion() {
    await this.alertService.confirm({
      messageKey: 'VEHICLE_REMOVE_FROM_FLEET',
      okHandler: async () => await this.deleteTruckData() 
    });
  }

  async deleteTruckData() {
    try {
      await this.spinnerService.show();

      const token = await this.authService.getToken();

      const truckId = this.truck.id;
      await this.truckService.deleteTruck(token, truckId);

      await this.alertService.toastSuccess();
      await this.spinnerService.dismiss();

      this.events.publish('callback-truck');

      this.router.navigate(['/profile'], { replaceUrl: true });
    } catch (err) {
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

}